// @flow
import { handleResponseOld, handleResponseWithNon200Errors, makeGet, makePost } from './helpers';

type FetchBidderDataParams = {
    authToken: string,
    deployment: string,
};

export const fetchBidderData = ({ authToken, deployment }: FetchBidderDataParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makeGet({ authToken, deployment, path: '<ITEM-API>auth/spauser' });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

type PostBidderConsentParams = {
    authToken: string,
    consent: any,
    context: any,
    deployment: string,
};

export const postBidderConsent = ({ authToken, consent, context, deployment }: PostBidderConsentParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({ apiPath: 'accepttermsofservice', authToken, deployment, path: '<USER-API>' });
        request.send({ acceptedTermsOfService: consent, context, signUpClient: 'web' });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

type FetchUpcomingDataParams = {
    authToken: string,
    bidderId: number,
    deployment: string,
};

export const fetchUpcomingItemData = ({ authToken, bidderId, deployment }: FetchUpcomingDataParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makeGet({
            authToken,
            deployment,
            path: '<ITEM-API>upcoming-items/bidder',
            queryParams: { bidderId },
        });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

export type UpdateProfileRequest = {
    address1: string,
    address2: string,
    city: string,
    country: string,
    email: string,
    firstName: string,
    lastName: string,
    mobile: string,
    phoneNumber?: string,
    state: string,
    zipcode: string,
};
type PostUpdateProfileParams = {
    authToken: string,
    deployment: string,
    profile: UpdateProfileRequest,
};
export const postUpdateProfile = ({ authToken, deployment, profile }: PostUpdateProfileParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({ apiPath: 'updateprofile', authToken, deployment, path: '<USER-API>' });

        // TODO: Flynn wants some fields in a different format, we need to get this standardized accross all apps
        const body: any = {
            address: profile.address1,
            address2: profile.address2,
            city: profile.city,
            country: profile.country,
            email: profile.email,
            firstName: profile.firstName,
            lastName: profile.lastName,
            mobileNumber: profile.mobile,
            // phoneNumber: '',
            state: profile.state,
            zip: profile.zipcode,
        };

        request.send(body);
        request.end((err, response) => handleResponseWithNon200Errors({ err, reject, resolve, response }));
    });

type PostCreateAccountParams = {
    agree: any,
    deployment: string,
    emailAddress: string,
    signupReferralHouse: number,
};

export const postCreateAccount = ({ agree, deployment, emailAddress, signupReferralHouse }: PostCreateAccountParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({ apiPath: 'createuser', deployment, path: '<USER-API>' });
        const requestBody: any = {
            acceptedTermsOfService: agree,
            client_version: '4.3',
            email_address: emailAddress,
            signup_client: 'web',
        };

        if (signupReferralHouse) {
            requestBody.referralHouse = `${signupReferralHouse}`;
        }
        request.send(requestBody);
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

type PostLoginParams = {
    deployment: string,
    mainhostLogin: any,
    password: ?string,
    username: string,
};

export const postLogin = ({ deployment, mainhostLogin, password, username }: PostLoginParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({ deployment, path: '<ITEM-API>auth/spalogin' });
        request.type('form');
        request.send({ password, username, ...mainhostLogin });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

type PostSetPasswordParams = {
    authToken: string,
    deployment: string,
    password: string,
};

export const postSetPassword = ({ authToken, deployment, password }: PostSetPasswordParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({ apiPath: 'createpassword', authToken, deployment, path: '<USER-API>' });
        request.send({ password });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

type PostSetSearchFacetOptionExclusionParams = {
    authToken: string,
    deployment: string,
    exclude: any,
    facetId: any,
    optionId: any,
};

export const postSetSearchFacetOptionExclusion = ({
    authToken,
    deployment,
    exclude,
    facetId,
    optionId,
}: PostSetSearchFacetOptionExclusionParams) =>
    new Promise<any>((resolve, reject) => {
        let requestURL;
        // transform the `exclude` bool into a number (0 or 1)
        const excludeBit = ~~exclude;

        switch (facetId) {
            case 'auctionHouse':
                requestURL = `<ITEM-API>search/exclusion/seller/${optionId}/${excludeBit}`;
                break;
            default:
                return reject(`Excluding search results by ${facetId} is not yet supported.`);
        }
        const request = makePost({ authToken, deployment, path: requestURL });
        request.send();
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
